// extracted by mini-css-extract-plugin
module.exports = {"content":"CardContent_content__Et9Z0"};